<template>
    <div :class="$style['page-container']">
      <!-- 左侧导航 -->
      <div :class="$style['page--left']">
        <pt-side-component-nav></pt-side-component-nav>
      </div>
      <!-- 右侧区域 -->
      <div :class="$style['page--right']">
        <!-- 用户信息 -->
        <pt-com-header></pt-com-header>
        <div :class="$style['page__content']">
            <!--<pt-page-breadcrumb :breadcrumbArr="currentBreadcrumbs"></pt-page-breadcrumb> -->
          <wt-view :class="[$style['page__content__view'],'shadow']"></wt-view>
        </div>
      </div>
    </div>
</template>

<script>
import ptComHeader from 'cps/pt-com-header'
// import ptPageBreadcrumb from 'cps/base/pt-page-breadcrumb'
import ptSideComponentNav from 'cps/pt-side-component-nav'
// import { updateBreadcrumb } from '@/utils/breadcrumb'
export default {
  name: 'component-nav',
  components: {
    ptComHeader,
    ptSideComponentNav
    // ptPageBreadcrumb
  },
  //   watch: {
  //     '$store.state.menuList': {
  //       handler: function (val) {
  //         this.menuList = val
  //       },
  //       immediate: true
  //     }
  //   },
  computed: {
    // currentRotute () {
    //   return this.$route
    // },
    // isEdit () {
    //   return this.$route.params && this.$route.params.isEdit && this.$route.params.isEdit === 'true'
    // },
    // newText () {
    //   return this.$route.meta && this.$route.meta.newText
    // },
    // isForm () {
    //   return this.$route.meta && this.$route.meta.isForm
    // },
    // currentBreadcrumbs () {
    //   return updateBreadcrumb(this.currentRotute, this.menuList, this.isForm, this.isEdit, this.newText)
    // }
  },
  data () {
    return {
      menuList: []
    }
  },
  created () {
  }
}
</script>
<style module lang="less">
.page-container{
  height: 100%;
  display: flex;

}
.page--left{
  width: 240PX;
  background-color:#454545;
  overflow-y: auto;
}
.page--right{
  flex:1;
  overflow-x: scroll;
  position: relative;
}
.page__content{
  margin-top:60PX;
  padding:40PX;
}
.page__content__view{
  height: 100%;
  border-radius: 10px;
  padding:40PX;
}
</style>
